import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
var TitleContainer = styled.div.withConfig({
    componentId: "sc-31341a7e-0"
})([
    "grid-area:title;min-width:16em;@media screen and (max-width:375px){min-width:12em;}"
]);
var TitleInternal = styled(Typography).attrs({
    forwardedAs: "h4",
    truncate: true
}).withConfig({
    componentId: "sc-31341a7e-1"
})([
    "&&&{padding-left:",
    ";word-break:break-word;white-space:normal;",
    "{text-align:",
    ";padding-left:0;}}"
], function(props) {
    return props.$noLeftTitlePadding ? "0px" : "20px";
}, responsiveMediaQueries.tabletAndAbove, function(param) {
    var $leftAlignTitle = param.$leftAlignTitle;
    return $leftAlignTitle ? "left" : "center";
});
var AuxiliaryTitleInternal = styled(Typography).withConfig({
    componentId: "sc-31341a7e-2"
})([
    "&&&{grid-area:auxiliary-title;text-align:right;padding-right:20px;",
    "{padding-right:0;}}"
], responsiveMediaQueries.tabletAndAbove);
var Wrapper = styled.div.withConfig({
    componentId: "sc-31341a7e-3"
})([
    'width:100%;display:grid;grid-template-columns:auto 1fr auto;grid-template-areas:"title . auxiliary-title" "children children children";grid-column-gap:10px;grid-row-gap:',
    ";",
    " ",
    "{grid-template-columns:1fr auto 1fr;grid-template-areas:",
    ' "children children children";grid-row-gap:22px;&.cart-page-carousel ',
    "{margin-left:-",
    ";}&.cart-page-carousel ",
    "{margin-right:-",
    ";}}"
], function(param) {
    var $increaseMobileRowSpacing = param.$increaseMobileRowSpacing;
    return $increaseMobileRowSpacing ? "16px" : "12px";
}, function(param) {
    var $showAuxiliaryTitleInternal = param.$showAuxiliaryTitleInternal;
    return $showAuxiliaryTitleInternal ? "align-items: center;" : "";
}, responsiveMediaQueries.tabletAndAbove, function(param) {
    var $leftAlignTitle = param.$leftAlignTitle;
    return $leftAlignTitle ? '"title . auxiliary-title"' : '". title auxiliary-title"';
}, TitleContainer, getSpacing("5x"), AuxiliaryTitleInternal, getSpacing("5x"));
Wrapper.displayName = "CarouselWithTitleWrapper";
var Header = styled(Typography).attrs({
    color: "graphite"
}).withConfig({
    componentId: "sc-31341a7e-4"
})([
    "&&&{padding-left:",
    ";",
    "{text-align:",
    ";padding-left:0;}}"
], function(props) {
    return props.$noLeftTitlePadding ? "0px" : "20px";
}, responsiveMediaQueries.tabletAndAbove, function(param) {
    var $leftAlignTitle = param.$leftAlignTitle;
    return $leftAlignTitle ? "left" : "center";
});
var Subtitle = styled(Typography).attrs({
    color: "graphite"
}).withConfig({
    componentId: "sc-31341a7e-5"
})([
    "&&&{padding-left:",
    ";white-space:nowrap;text-overflow:ellipsis;overflow:hidden;",
    "{text-align:",
    ";padding-left:0;}}"
], function(props) {
    return props.$noLeftTitlePadding ? "0px" : "20px";
}, responsiveMediaQueries.tabletAndAbove, function(param) {
    var $leftAlignTitle = param.$leftAlignTitle;
    return $leftAlignTitle ? "left" : "center";
});
var Children = styled.div.withConfig({
    componentId: "sc-31341a7e-6"
})([
    "grid-area:children;width:100%;"
]);
export var CarouselWithTitleShell = function(param) {
    var className = param.className, title = param.title, seeAllLink = param.seeAllLink, seeAllOnClick = param.seeAllOnClick, leftAlignTitle = param.leftAlignTitle, titleRight = param.titleRight, subtitle = param.subtitle, children = param.children, dataTestId = param.dataTestId, header = param.header, increaseMobileRowSpacing = param.increaseMobileRowSpacing, noLeftTitlePadding = param.noLeftTitlePadding, _param_titleTypography = param.titleTypography, titleTypography = _param_titleTypography === void 0 ? "pageHeaderSerifRegular" : _param_titleTypography, innerRef = param.innerRef;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var showAuxiliaryTitleInternal = !!(titleRight || seeAllLink);
    return /*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        $leftAlignTitle: leftAlignTitle,
        "data-test-id": dataTestId,
        $showAuxiliaryTitleInternal: showAuxiliaryTitleInternal,
        $increaseMobileRowSpacing: increaseMobileRowSpacing,
        ref: innerRef,
        children: [
            /*#__PURE__*/ _jsxs(TitleContainer, {
                children: [
                    header ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Header, {
                                $noLeftTitlePadding: noLeftTitlePadding,
                                $leftAlignTitle: leftAlignTitle,
                                children: header
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: 4
                            })
                        ]
                    }) : null,
                    title ? /*#__PURE__*/ _jsx(TitleInternal, {
                        $noLeftTitlePadding: noLeftTitlePadding,
                        $leftAlignTitle: leftAlignTitle,
                        maxLines: 2,
                        variant: titleTypography,
                        children: title
                    }) : null,
                    subtitle ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: 4
                            }),
                            /*#__PURE__*/ _jsx(Subtitle, {
                                $noLeftTitlePadding: noLeftTitlePadding,
                                $leftAlignTitle: leftAlignTitle,
                                children: subtitle
                            })
                        ]
                    }) : null
                ]
            }),
            showAuxiliaryTitleInternal ? /*#__PURE__*/ _jsx(AuxiliaryTitleInternal, {
                forwardedAs: "span",
                children: seeAllLink ? /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    linkTo: seeAllLink,
                    onClick: seeAllOnClick,
                    "data-test-id": "see-all-link",
                    children: titleRight ? titleRight : strictLocalize({
                        id: "kWg8zV",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "See All"
                            }
                        ]
                    })
                }) : titleRight
            }) : null,
            /*#__PURE__*/ _jsx(Children, {
                children: children
            })
        ]
    });
};
CarouselWithTitleShell.Container = Wrapper;
CarouselWithTitleShell.Title = TitleInternal;
CarouselWithTitleShell.AuxiliaryTitle = AuxiliaryTitleInternal;
CarouselWithTitleShell.Content = Children;
